import { requestWithToken } from '../utilities/request';

const path = '/api/private/companies';

const partnerCompanyBranchList = (companyId, param, isQuiet = false) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${companyId}/partner_company_branches`),
    params: param,
    isQuiet,
  });
};

const show = (companyId, partnerCompanyBranchId, isQuiet = false) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(
      `/${companyId}/partner_company_branches/${partnerCompanyBranchId}`
    ),
    isQuiet,
  });
};

const partnerCompanyBranch = (companyId, param) => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(`/${companyId}/partner_company_branches`),
    data: param,
  });
};

const updatePartnerCompanyBranch = (
  companyId,
  partnerCompanyBranchId,
  param
) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(
      `/${companyId}/partner_company_branches/${partnerCompanyBranchId}`
    ),
    data: param,
  });
};

export const PartnerCompanyBranchService = {
  partnerCompanyBranchList,
  show,
  partnerCompanyBranch,
  updatePartnerCompanyBranch,
};

export default PartnerCompanyBranchService;



// WEBPACK FOOTER //
// ./src/services/PartnerCompanyBranch.js